<section class="page-container">
    <div class="container-fluid ptCustom">
        <div class="row mt-4 submitMemberNews">
            <div class="col-12">
                <div class="row justify-content-center">
                    <div class="col-md-6">
                        <div class="submitMemberNewsWrap mt-4">
                            <div class="row gx-5 submitMemberNewsForm">
                                <div class="col-12">
                                    <div class="mb-4">
                                        <label for="notesTo" class="form-label">
                                            Notes
                                        </label>
                                        <input [(ngModel)]="memberNotes" name="memberNotes" type="text"
                                               class="form-control" id="notesTo" placeholder="Notes" value="">
                                    </div>
                                    <div class="mb-4">
                                        <label for="url" class="form-label">Ad Url</label>
                                        <input [(ngModel)]="adUrl" name="adUrl" type="text" class="form-control"
                                               id="notesTo" placeholder="Url" value="">
                                    </div>

                                <div class="fancyRadioWrap p-3 rounded mb-4" *ngIf="adTypes?.length > 0">
                                    <span class="d-block fs-3 mb-1">Ad Type</span>
                                    <div class="fancyRadio" *ngFor="let type of adTypes">
                                        <label class="radioCard card mb-3">
                                            <div class="card-body d-flex align-items-start gap-3 py-3">
                                                <input class="form-check-input" type="radio" name="option" [value]="type.type" [(ngModel)]="selectedAdTypeId">
                                                <div>
                                                    <div class="radioTitle">{{type.name}}</div>
                                                    <p class="radioDesc">{{getAdTypeTooltip(type.type)}}</p>
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                    <div *ngIf="invalidSelectedAd && selectedAdType.type < 0">
                                        <i class="fas fa-exclamation-circle"></i> Ad Type is required.
                                    </div>
                                </div>

                                    <div class="mb-4" *ngIf="selectedAdType.type > 0">
                                        <label for="adSize" class="form-label fs-3">Ad Size required: </label>
                                        <h6 style="color: #BEBEBE;">  {{selectedAdType.sizeRequirement}}</h6>
                                    </div>
                                    <div class="mb-4">
                                        <label *ngIf="groupType == 1" for="runDate" class="form-label">Proposed Date to Run (Based on Availability)</label>
                                        <label *ngIf="groupType != 1" for="runDate" class="form-label">Date to Begin Running (Runs for 30 Days)</label>
                                        <input [(ngModel)]="runDate" type="text" class="form-control"
                                               id="runDate" placeholder="mm/dd/yyyy">
                                        <div *ngIf="invalidRun">
                                            <i class="fas fa-exclamation-circle"></i> Date is invalid.
                                        </div>
                                    </div>
                                    <div *ngIf="selectedAdType.type >= 0" class="mb-4">
                                        <label for="adImg" class="form-label">
                                            Advertisement Image <a href="javascript:void(0);" class="formTooltip" placement="top"
                                                                   ngbTooltip="All ads must be under 75KB
                                                Allowed file types: jpeg, jpg, png, webp
                                                ">
                                                <i class="fa-solid fa-circle-question"></i>
                                            </a>
                                        </label>
                                        <input accept="image/*" (change)="updateAdImage($event.target.files)"
                                               class="form-control" type="file" id="adImg">
                                        <div *ngIf="adImage == null && submitPressed">
                                            <i class="fas fa-exclamation-circle"></i> Image is required.
                                        </div>
                                    </div>
                                    <div class="mb-4" *ngIf="adImage != null">
                                        <label for="articleImg" class="form-label">Ad Preview (not true to size)</label>
                                        <div class="imagePreview adPreview">
                                            <img [src]="preview" alt="ad preview" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 text-center mt-4">
                                    <button (click)="submitAd()" [disabled]="disabledSubmitButton" type="button"
                                        class="btn btn-secondary m-100 newsSubmitBtn">Submit Advertisement</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>